<template>
  <div
    class="FarmSliderItem farm-slider-item"
    :class="{ 'is--visible': visible }"
  >
    <FarmItem
      :farm="farmData"
      for-slider
      force-load-farm-image
      class="farm-slider-item__farm"
    />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IFarmItem } from 'Models';
import FarmItem from 'Components/FarmItem/FarmItem.vue';

export default defineComponent({
  name: 'FarmSliderItem',
  components: {
    FarmItem,
  },
  props: {
    farmData: Object as PropType<IFarmItem>,
    visible: Boolean,
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.farm-slider-item
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 540px
  z-index: 1
  @media screen and (min-width: 768px) and (max-width: 1170px)
    height: 100%
  &__farm
    background: transparent
    align-items: center
  :deep(.farm-item-content)
    opacity: 0
  :deep(.farm-item-header)
    transition: all 0.4s ease-in-out
    opacity: 0
    filter: alpha(opacity=0)
  @media screen and (min-width: 768px) and (max-width: 1170px)
    opacity: 0
    .farm-slider-item__farm
      margin: 0
      :deep(.content-list-invest)
        flex-direction: column
        .btn
          margin-bottom: 15px
          margin-top: 4px
      :deep(.farm-item-content)
        width: 100%
  @media (min-width: 1171px), screen and (max-width: 767px)
    .farm-slider-item__farm
      margin: 0
      max-width: 392px
      border: none
      box-shadow: none
      .hidden-background
        position: absolute
        right: 0
        top: 0
      :deep(.farm-item-header)
        height: 540px !important
        border-radius: 10px
        img
          opacity: 0
          transition: all 0.3s linear
        .header-img
          border-radius: 10px
      :deep(.farm-item-header__label)
        @media screen and (max-width: 767px)
          left: 20px !important
          top: 20px !important
      &:hover
        box-shadow: none
        transform: translateY(0px)
      :deep(.farm-item-content)
        position: absolute !important
        left: 55% !important
        bottom: 16% !important
        width: 362px !important
        border-radius: 5px
        border: 1px solid $support_lightgray
        background-color: $white
        z-index: 1
        box-shadow: none !important
        overflow: visible !important
        @media screen and (max-width: 1400px) and (min-width: 1260px)
          left: 145px !important
        @media screen and (max-width: 1259px) and (min-width: 1171px)
          left: 100px !important
        @media screen and (max-width: 1170px)
          left: auto !important
          right: 15px !important
        @media screen and (max-width: 830px) and (min-width: 768px)
          right: 0 !important
        @media screen and (max-width: 767px)
          right: auto !important
          bottom: -110px !important
          &:before
            left: -5px !important
            top: -5px !important
            width: calc(100% + 10px) !important
            height: calc(100% + 10px) !important
          &:after
            left: -5px !important
            top: -5px !important
            width: calc(100% + 10px) !important
            height: calc(100% + 10px) !important
          .content-list
            padding: 15px 20px 10px 20px !important
        @media screen and (max-width: 576px)
          width: 314px !important
        :deep(.farm-item-content-wrap)
          overflow: hidden
        &:before
          opacity: 1 !important
        .content-header
          border-top-left-radius: 5px
          border-top-right-radius: 5px
        .content-list
          border-bottom-left-radius: 5px
          border-bottom-right-radius: 5px
          background-color: $alabaster
          &.is-blurred
            .content-list-invest
              filter: blur(0px)
              position: relative
              border-top: 1px solid transparent
              &:before
                position: absolute
                content: ''
                left: 0
                top: 0px
                width: 100%
                height: 15px
                filter: blur(4px)
                border-top: 1px solid $mercury
              .price-wrap
                filter: url('#blur')
          &-invest
            display: flex !important
            flex-direction: column !important
  @media screen and (max-width: 576px)
    .farm-slider-item__farm
      :deep(.farm-item-header)
        height: 640px !important
  &.is--visible
    z-index: 2
    @media screen and (min-width: 768px) and (max-width: 1170px)
      opacity: 1
    :deep(.farm-item-content)
      opacity: 1
    :deep(.farm-item-header)
      opacity: 1
      filter: alpha(opacity=100)
      transition: all 0.4s ease-in-out
      img
        opacity: 1
        transition: all 0.3s linear

@keyframes hide
  0%
    opacity: 1
    visibility: visible
  100%
    opacity: 0
    visibility: hidden
@keyframes show
  0%
    opacity: 0
    visibility: hidden
  100%
    opacity: 1
    visibility: visible
</style>
